@if(user) {
    <div class="container">
           <div class="row row-cols-auto justify-content-lg-start justify-content-center pt-4" >
               @if(quickLinks && quickLinks.length > 0) {
                   @for (tile of quickLinks; track tile) {
                       <div class="col">
                           <div class="tileUser">
                               <a [href]="tile.link">
                                   <div class="img-wrapper" [ngStyle]="{'background-image': 'url(' + tile.imageUrl +')'}">

                                   </div>
                                   <div class="txt-wrapper">
                                       <div class="title">
                                           {{tile.title}}
                                       </div>
                                       <div class="subTitle">{{tile.subtitle}}</div>
                                   </div>

                               </a>
                           </div>
                       </div>
                   }
               }
              <!-- <div class="col">
                   <div class="tileUser feedback-tile">
                       <a routerLink = '/feedback'>
                           <div class="img-wrapper" [ngStyle]="{'background-image': 'url()'}">
                           </div>
                           <div class="txt-wrapper">
                               <div class="title">
                                   {{'feedback' | translate}}
                               </div>
                           </div>
                       </a>
                   </div>
               </div>-->
               <div class="col">
                   <div class="tileUser transfer-tile">
                       <a href='https://head.wetransfer.com' target="_blank">
                           <div class="img-wrapper" [ngStyle]="{'background-image': 'url()'}">
                           </div>
                           <div class="txt-wrapper">
                               <div class="title">
                                   WeTransfer Portal
                               </div>
                           </div>
                       </a>
                   </div>
               </div>
           </div>
    </div>

} @else {
        @if(staticTiles && staticTiles.length > 0) {
            <div class="tiles-wrapper" appFullHigh>
                <div class="row row-cols-auto justify-content-center pt-4" >

                    @for(tile of staticTiles; track tile) {
                        <div class="col">

                            <div class="tile">
                                <a [href]="tile.url">
                                <div class="img-wrapper">
                                    <img src="{{tile.image}}" alt={{tile.name}}>
                                </div>
                                <div class="name">
                                    {{tile.name}}
                                </div>
                                </a>
                            </div>

                        </div>
                    }

                </div>
            </div>
        }
}





